<template>
	<div id="appTop">
		<!-- Alert board -->
		<!-- <div class="bg-danger text-light py-1 text-center">
			<marquee scrollamount="3" onmouseover="this.stop();" onmouseout="this.start();">
				Hurray! aNewItem rebranded is live! Just a few tweaks here and there and we will resume transactions again.
				Thank you for your patience, support and love. Team aNewItem 
			</marquee>
		</div> -->
		
		<!-- Intl. shopping notice -->
		<div class="hide-on-desktop">
			<div v-if="intlShopping" class="bg-dark text-light py-1 text-center">
				<router-link :to="{ name: 'settings', query: { location: null } }">
					I'm currently shopping in 
					<span class="text-uppercase">{{intlShopping.currency}}</span>
					<span class=""><i :class="`flag flag-${intlShopping.alphaCode} mx-1`"></i></span>
					<span class="ml-1">
						<i class="fas fa-window-close fa-sm" title="Turn off intl. shopping"></i>
					</span>
				</router-link>
			</div>
		</div>

		<!-- Component layout selector -->
		<component :is="layout">
			<router-view :layout.sync="layout"/>
			<app-loader v-if="pageSpinner"></app-loader>
		</component>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '@/components/general/shared/Loader.vue'

export default {
	name: 'App',
	data() {
		return {
			layout: 'div',
		}
	},
	methods: {
        ...mapActions(['fetchConditions', 'fetchCategories', 'mostCategoryAction', 'setCurrencyAction', 'showHeaderSearchBarAction']),
	},
	computed: {
		...mapGetters(['pageSpinner', 'user', 'authenticated']),
		intlShopping() {
            if(this.authenticated && this.user){
                if(this.user.intlShpAlphaCode && (this.user.alphaCode !== this.user.intlShpAlphaCode)){
                    let obj = {
                        alphaCode: this.user.intlShpAlphaCode,
                        currency: this.user.intlShpCurrency
                    }
                    return obj
                }
            }
            return false
        }
	},
	components: {
		appLoader: Loader
	},
	created() {
        // compulsory needed for the site to fxn
		this.fetchCategories().then(() => {}).catch((e) => {})
		this.fetchConditions().then(() => {}).catch((e) => {})
		// from rebranded aNewItem
		this.mostCategoryAction().then(() => {}).catch((e) => {})
		this.setCurrencyAction().then(() => {}).catch((e) => {})
		this.showHeaderSearchBarAction(true).then(() => {}).catch((e) => {})
    },
}
</script>
